var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-social d-flex justify-end"},_vm._l((_vm.sharelinks),function(ref,i){
var link = ref.link;
var icon = ref.icon;
var text = ref.text;
return _c('TooltipWidget',{key:i,attrs:{"bottom":"","tip":("Compartilhar no " + text)}},[_c('v-btn',{attrs:{"icon":"","target":"_blank","href":link + _vm.currentUrl,"width":_vm.smAndDown ? "30px" : "38px","height":_vm.smAndDown ? "30px" : "38px"}},[_c('v-icon',{attrs:{"size":_vm.smAndDown ? "16" : "20","color":"primary"}},[_vm._v(_vm._s(icon))])],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }